import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SiteDetailsStep = ({ formData, errors, handleInputChange }) => {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 md:p-6">
        <div className="flex gap-3 md:gap-4">
          <div className="flex-shrink-0">
            <Icon name="Info" size={24} color="var(--color-accent)" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-2 text-sm md:text-base lg:text-lg">
              About Your First Site
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              Enter the basic details for your first construction site. You'll be able to add documents, assign workers, and track compliance after completing this setup.
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <Input
          label="Site Name"
          type="text"
          name="siteName"
          placeholder="e.g., Riverside Development Phase 1"
          value={formData?.siteName}
          onChange={handleInputChange}
          error={errors?.siteName}
          required
          description="A clear, descriptive name for this construction site"
        />

        <Input
          label="Site Reference/Code"
          type="text"
          name="siteReference"
          placeholder="e.g., RD-P1-2026"
          value={formData?.siteReference}
          onChange={handleInputChange}
          description="Optional internal reference code for your records"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="Project Start Date"
            type="date"
            name="startDate"
            value={formData?.startDate}
            onChange={handleInputChange}
            error={errors?.startDate}
            required
            description="When work begins on site"
          />

          <Input
            label="Expected End Date"
            type="date"
            name="endDate"
            value={formData?.endDate}
            onChange={handleInputChange}
            error={errors?.endDate}
            required
            description="Estimated project completion date"
          />
        </div>
      </div>
    </div>
  );
};

export default SiteDetailsStep;